import { useCallback, useState } from "react"

const useUbicacion=()=>{
  const [ubicacion, setUbicacion] = useState({
    latitud: null,
    longitud: null,
    direccion: null,
    estado: false,
    mensaje:''
  });

  const obtenerUbicacion = useCallback(()=>{
    return new Promise((resolve, reject)=>{
      if(!('geolocation' in navigator)){
        setUbicacion((prev)=>({
          ...prev,
          estado: false,
          mensaje:'Geolocalización no soportada por este navegador'
        }));
        return resolve();
      }

      navigator.geolocation.getCurrentPosition(
        async(pos)=>{
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`
            );
            if (!response.ok) throw new Error('Error al consultar Nominatim');
            const data = await response.json();
  
            setUbicacion({
              latitud: lat,
              longitud: lon,
              direccion: data.display_name || '',
              estado: true,
              mensaje: 'Ubicación obtenida correctamente',
            });
            resolve();
          } catch (err) {
            setUbicacion({
              latitud: lat,
              longitud: lon,
              direccion: '',
              estado: false,
              mensaje: 'No se pudo obtener la dirección.',
            });
            reject(err);
          }
        },
        (error)=>{
          setUbicacion({
            latitud: null,
            longitud: null,
            direccion: '',
            estado: false,
            mensaje: 'Error al obtener ubicación: ',
          });
          reject(error);
        }
      );
    });
  },[]);

  return{
    ubicacion,
    actualizarUbicacion: obtenerUbicacion
  };
};

export default useUbicacion;